import MainList from './MainList.vue';

export default MainList;
